<template>

  <PreavvisiInvio />

</template>

<script>
import PreavvisiInvio from '../components/pratiche/PreavvisiInvio.vue'

export default {
  pageName: 'PreavvisiInvio',
  components: {
    PreavvisiInvio

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
